@if (user) {
  <app-sidebar
    [ngClass]="{ collapsed: menuCollapsed, expanded: !menuCollapsed }"
    [user]="user"
    [showOptions]="showOptions"
    [options]="menuOptions"
    (isCollapsed)="setCollapse($event)"
    (logOut)="logOut()"
  ></app-sidebar>
}

<div class="page">
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>

<p-toast key="global"></p-toast>

@if (loadingService.isLoading()) {
  <div class="loading-indicator" aria-live="polite" aria-busy="true">
    <app-spinner />
  </div>
}
